import type { UrlPolicy } from "@zsherman/editor";

/** Web and mail links, and links inside the app (`/notes/<id>`). Matches `safeLink`. */
export const HQ_URL_POLICY: UrlPolicy = {
  allowedSchemes: ["http", "https", "mailto"],
  internalSchemes: [],
  allowRelative: true,
};
